<template>
    <div class="summary__address w-100 w-third-ns">
        <div v-bind:class="{ deactive: selected != address.id }">
            <b>{{ address.name }} {{ address.surname }}</b><br>
            <span v-if="address.company_name || address.companyName">
                {{ address.company_name || address.companyName }}<br>
            </span>
            {{ address.address }}<br>
            {{ address.city }}, {{ address.zip_code }} {{ address.district }}<br>
            {{ address.country.iso_code || address.country }}<br>
            {{ address.telephone }}
        </div>
        <button v-if="selected != address.id" v-on:click="$emit('set-address-on', address.id)">
            {{ strings['select'] }}
        </button>
    </div>
</template>

<script>
module.exports = {
    props: [
        'address',
        'strings',
        'selected',
        'alternative',
    ]
}
</script>
